import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  standalone: false,
})
export class PrivacyPolicyComponent {
  constructor(private router: Router, private location: Location) {}

  returnHome() {
    this.location.back();
  }

  downloadPolicy(): void {
    const link = document.createElement('a');
    link.href = 'assets/documents/privacy-policy.docx';
    link.download = 'ArtisanSonics-Privacy-Policy.docx';
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
